import { useContext } from "react";
import { AuthContext } from "../Contexts/AuthContext";

interface UseCanParams {
    rolesCan?: string[];
}

export default function useCan({ rolesCan = [] }: UseCanParams) {
    const { roles } = useContext(AuthContext);

    if (roles.length === 0) {
        return false;
    }

    if (rolesCan?.length > 0) {
        const hassAllRoles = rolesCan.some(role => {
            return roles.includes(role);
        });

        if (!hassAllRoles)
            return false;
    }

    if (roles && roles.includes("Manager"))
        return true;

    return true;
}